import { motion } from 'framer-motion';
import logo from '../assets/logo.png';
import './Animation.css';

export default function Animation({ onComplete }) {
  return (
    <motion.div
      className="intro-logo-scene"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.img
        src={logo}
        alt="in’Symphonia  Powered by NHI"
        className="intro-logo"
        initial={{
          opacity: 0,
          scale: 0.72,
          rotateX: 18,
          rotateY: -38,
          rotateZ: -3,
          z: -250,
        }}
        animate={{
          opacity: [0, 1, 1, 1, 0],
          scale: [0.72, 0.9, 1.05, 1, 1.08],
          rotateX: [18, -7, 3, 0, 0],
          rotateY: [-38, 22, -8, 0, 0],
          rotateZ: [-3, 2, -1, 0, 0],
          z: [-250, 80, 25, 0, 100],
        }}
        transition={{
          duration: 3.8,
          times: [0, 0.32, 0.62, 0.82, 1],
          ease: [0.22, 1, 0.36, 1],
        }}
        onAnimationComplete={onComplete}
      />
    </motion.div>
  );
}